// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__2DZry","row":"Node_row__18RIh","label":"Node_label__1uPyH","footer":"Node_footer__36JOz"};